'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _PhotoSwipeJs = require('./PhotoSwipe.js');

var _PhotoSwipeJs2 = _interopRequireDefault(_PhotoSwipeJs);

var _PhotoSwipeGalleryJs = require('./PhotoSwipeGallery.js');

var _PhotoSwipeGalleryJs2 = _interopRequireDefault(_PhotoSwipeGalleryJs);

module.exports = {
  PhotoSwipe: _PhotoSwipeJs2['default'],
  PhotoSwipeGallery: _PhotoSwipeGalleryJs2['default']
};


//////////////////
// WEBPACK FOOTER
// ./~/react-photoswipe/lib/index.js
// module id = 233
// module chunks = 0